import type { CSSProperties } from 'react'
import { cn } from '@/lib/utils'

/** Illustrazioni della festa disegnate da Muse Spark (SVG in public/illustrations/). */
export type StickerName =
  | 'balloons'
  | 'beer-pong'
  | 'cap-hero'
  | 'cap-toss'
  | 'coins'
  | 'diploma'
  | 'mascot'
  | 'party-hat'
  | 'toast'
  | 'trophy'

type StickerProps = {
  name: StickerName
  className?: string
  /** Galleggia piano (solo senza "riduci movimento"); `delay` in secondi sfasa gli sticker vicini. */
  float?: boolean
  delay?: number
  /** Rotazione di partenza in gradi, così gli sticker non stanno tutti dritti. */
  rotate?: number
  /** Testo alternativo: vuoto (decorativo) se non serve. */
  alt?: string
  priority?: boolean
  /** Su fondo scuro: bordo bianco da sticker, così i contorni indaco restano visibili. */
  onDark?: boolean
}

/** Sticker decorativo quadrato; la misura si dà con `className` (es. `size-40`). */
export function Sticker({ name, className, float = false, delay = 0, rotate = 0, alt = '', priority = false, onDark = false }: StickerProps) {
  const style = { rotate: `${rotate}deg`, animationDelay: `${delay}s` } as CSSProperties
  return (
    <img
      src={`/illustrations/${name}.svg`}
      alt={alt}
      aria-hidden={alt ? undefined : true}
      width={400}
      height={400}
      loading={priority ? 'eager' : 'lazy'}
      decoding="async"
      draggable={false}
      style={style}
      className={cn('pointer-events-none select-none', float && 'motion-safe:animate-float', onDark && 'sticker-outline', className)}
    />
  )
}
